export function syncMobileNativeLocalization(state) {
    const device = window.reactNativeDevice;
    if (!(device === null || device === void 0 ? void 0 : device.syncMobileLocalization)) {
        return;
    }
    void device.syncMobileLocalization(state).catch((error) => {
        console.error('Failed to sync mobile native localization', error);
    });
}
